import { LadiesMain } from "../global/ladies-main.ts"
import { isMobile } from "../util/device"

export type AutocompleteItem = {
    Land: string
    Slug: string
    Name: string
    LocationId: number
    Plz: string
    Type: string
    Category: string
    label: string
    plz: string | undefined
}

export type AutocompleteConfig = {
    delay?: number
    minLength?: number
    autoFocus?: boolean
    elementsInput?: typeof $
    resultsElement?: typeof $
    elementsForm?: typeof $
}

export class Autocomplete {
    config: AutocompleteConfig
    autocompleteInstance: any
    exactTrefferFound: boolean
    inputSelected: boolean
    actualInputValue: any
    currentSearchText: string
    focusedItem: AutocompleteItem | null = null
    enterPressed: boolean
    showAlleRegionenList: boolean

    constructor(config: AutocompleteConfig) {
        this.config = config

        if (this.config.elementsInput === undefined) {
            throw "Autocompletes elementsInput Variable muss in der Konfiguration definiert werden und auf ein Input-Feld verweisen"
        }

        if (this.config.delay === undefined) this.config.delay = 600

        if (this.config.minLength === undefined) this.config.minLength = 0

        if (this.config.autoFocus === undefined) this.config.autoFocus = true

        this.autocompleteInstance = null

        this.exactTrefferFound = false

        this.inputSelected = false

        this.actualInputValue = null

        this.currentSearchText = ""

        this.enterPressed = false

        this.showAlleRegionenList = false
    }

    init() {
        const autocompleteElements = $(this.config.elementsInput)

        if (!autocompleteElements.length || !autocompleteElements.autocomplete) {
            return
        }

        this.autocompleteInstance = autocompleteElements.autocomplete({
            delay: this.config.delay,
            minLength: this.config.minLength,
            autoFocus: this.config.autoFocus,
            appendTo: SiteInfo.isIndex ? "body" : ".input-group-regiosuche",
            select: this.select.bind(this),
            source: this.source.bind(this),
            close: this.close.bind(this),
            change: this.change.bind(this),
            open: this.open.bind(this),
            search: this.search.bind(this),
            focus: this.focus.bind(this),
        })

        if (this.autocompleteInstance.data("autocomplete")) {
            this.autocompleteInstance.data("autocomplete")._renderItem = this._renderItem.bind(this)
            this.autocompleteInstance.data("autocomplete")._renderMenu = this._renderMenu.bind(this)
        }

        this.initSavedSuggestions()

        this._eventInputClicked()

        this._eventInputBlurred()

        this._eventInputChanged()

        this._eventFormSubmitted()

        this._eventEnterPressed()
    }

    initSavedSuggestions() {
        if (!siteConfig.locationSuggestions) {
            siteConfig.locationSuggestions = []
        }

        if (siteConfig.locationSuggestions.constructor !== Array) {
            const newSuggestionsArray: string[] = []
            $.each(siteConfig.locationSuggestions, (_: string, option: string) => {
                newSuggestionsArray.push(option)
            })
            siteConfig.locationSuggestions = newSuggestionsArray
        }
    }

    sourceLazy = (_: any, response: any) => response(siteConfig.locationSuggestions)

    source = (_: any, response: any) => {
        console.error("Überschreibe source-Methode!")
        return response([])
    }

    select(_: Event, __: any) {
        $(this.config.elementsInput).removeClass("autocomplete-open")
        console.error("Überschreibe select-Methode!")
    }

    close(_: Event, __: any) {
        $(this.config.elementsInput).removeClass("autocomplete-open")
    }

    change = (_: Event, __: any) => {}

    open = (_: Event, __: any) => {}

    search = (_: Event, __: any) => {}

    focus(_: any, ui: any) {
        this.focusedItem = ui.item
    }

    _renderMenu(ul: any, items: AutocompleteItem) {
        $.each(items, (_: number, item: typeof $) => {
            this._renderItem(ul, item)
        })

        $(".ui-autocomplete").addClass("active")
    }

    _renderItem(ul: any, item: AutocompleteItem) {
        if (this.config.resultsElement) {
            ul.appendTo($(this.config.resultsElement))
        }

        return $("<li></li>").data("item.autocomplete", item).append(`<a>${item.label}</a>`).appendTo(ul)
    }

    _updateRegioUrl(url: string, data = {}) {
        if (isMobile()) {
            $(document).trigger("updated.regio:Autocomplete", [data])

            if ("index" !== SiteInfo.controller) {
                return
            }
        }

        let newUrl = url.replace(/(\/)+/g, "$1")

        if ("einzelansicht" === SiteInfo.controller && !("filterUrl" in SiteInfo)) {
            newUrl = newUrl.substr(0, newUrl.lastIndexOf("/"))
        }

        let controllerName = ""
        if (typeof SiteInfo !== "undefined") {
            controllerName = SiteInfo.controller || ""
        }

        if ("anzeigenmarkt" === controllerName) {
            newUrl = this.clearUrl(newUrl)
        }

        $(".regio-form").addClass("submit-disabled")

        location.href = newUrl
    }
    _eventInputClicked(this: Autocomplete) {
        const _this = this

        $(this.config.elementsInput).click(function (this: Autocomplete) {
            if (isMobile() && SiteInfo.controller === "index") {
                LadiesMain.jumpToScrollPoint($(".scrollpoint"))
            }

            if (_this.inputSelected === false) {
                $(this).select()
                _this.inputSelected = true
            }

            $(this).autocomplete({
                source: _this.sourceLazy.bind(_this),
                autoFocus: true,
                minLength: 0,
            })

            $(this).autocomplete("search", "")
        })
    }

    _eventInputBlurred() {
        $(this.config.elementsInput).blur(() => {
            this.inputSelected = false
        })
    }

    _eventInputChanged() {
        $(this.config.elementsInput).bind("paste", (e: Event) => {
            this._inputDataPasted(e)
        })

        $(this.config.elementsInput).on("keyup change propertychange paste input", this._inputDataChanged.bind(this))
    }

    _eventFormSubmitted() {
        if ($(this.config.elementsForm).length) {
            $(this.config.elementsForm).on("submit", this._formSubmitted.bind(this))
        }
    }

    _eventEnterPressed() {
        $("#regiosuche").keyup((e: KeyboardEvent) => {
            if (e.keyCode === 13 || e.keyCode === 108) {
                this._enterPressed(e)
            }
        })
    }

    _inputDataPasted(_: Event) {
        setTimeout(() => {
            $(this.config.elementsInput).autocomplete("search", $(this.config.elementsInput).val())
        }, 50)
    }

    _inputDataChanged(keyEvent: KeyboardEvent) {
        const regioSearchElement = $(this.config.elementsInput)

        $(keyEvent.currentTarget).autocomplete({
            source: this.source.bind(this),
            minLength: 2,
            autoFocus: true,
        })

        if (regioSearchElement.val() === "") {
            regioSearchElement.data("regioSlug", regioSearchElement.val())

            if (isMobile()) {
                $(document).trigger("updated.regio:Autocomplete", [
                    { plz: "", slug: "", type: "overall", cleared: true },
                ])
            }
        }
    }

    _formSubmitted(keyEvent: KeyboardEvent) {
        keyEvent.preventDefault()
    }

    _enterPressed(_: KeyboardEvent) {}

    clearUrl(urlComplete: string) {
        return urlComplete
    }
}
